import React from "react"

const Center = () => (
  <svg
    width="166"
    height="166"
    viewBox="0 0 166 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_iA)">
      <circle
        cx="82.9999"
        cy="82.9999"
        r="56.8182"
        fill="url(#paint0_linearA)"
      />
    </g>
    <circle
      cx="83"
      cy="83"
      r="65.9091"
      stroke="#9DD0FF"
      stroke-opacity="0.5"
      stroke-width="7.57576"
    />
    <circle
      cx="83"
      cy="83"
      r="78.7879"
      stroke="#9DD0FF"
      stroke-opacity="0.25"
      stroke-width="7.57576"
    />
    <g filter="url(#filter1_iA)">
      <path
        d="M80.3485 49.4636C81.7548 48.6517 83.4875 48.6517 84.8939 49.4636L110.2 64.0742C111.606 64.8861 112.473 66.3867 112.473 68.0107V97.2317C112.473 98.8557 111.606 100.356 110.2 101.168L84.8939 115.779C83.4875 116.591 81.7548 116.591 80.3485 115.779L55.0423 101.168C53.6359 100.356 52.7696 98.8556 52.7696 97.2317V68.0107C52.7696 66.3867 53.6359 64.8861 55.0423 64.0742L80.3485 49.4636Z"
        stroke="white"
        stroke-width="3.0303"
      />
      <circle
        cx="83"
        cy="83"
        r="7.57576"
        stroke="white"
        stroke-width="3.0303"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M79.2121 64.4394L79.2121 67.5445C74.9105 68.5952 71.2947 71.3948 69.1609 75.1471L66.5499 73.6074C69.2123 68.9545 73.792 65.5396 79.2121 64.4394ZM82.9999 67.0908C82.746 67.0908 82.4934 67.0968 82.2424 67.1086V64.0754C82.4937 64.0655 82.7462 64.0605 82.9999 64.0605C88.8235 64.0605 94.0331 66.6889 97.5073 70.824L94.8532 72.3884C91.9403 69.1369 87.709 67.0908 82.9999 67.0908ZM96.6603 74.8408C98.0883 77.2265 98.909 80.0174 98.909 82.9999C98.909 84.5356 98.6915 86.0204 98.2855 87.4252L100.959 89.0295C101.595 87.1356 101.939 85.108 101.939 82.9999C101.939 79.4555 100.966 76.1386 99.2713 73.3018L96.6603 74.8408ZM83.7576 98.8913C83.5065 98.9031 83.2539 98.909 82.9999 98.909C78.5424 98.909 74.513 97.0758 71.6247 94.1221L68.9561 95.7073C72.4215 99.5349 77.4299 101.939 82.9999 101.939C83.2537 101.939 83.5063 101.934 83.7576 101.924V98.8913ZM67.0908 82.9999C67.0908 86.2275 68.052 89.2306 69.7037 91.7386L67.0956 93.2878C65.1755 90.3255 64.0605 86.7929 64.0605 82.9999C64.0605 80.6646 64.4832 78.428 65.2562 76.3624L67.9155 77.9307C67.3807 79.5229 67.0908 81.2276 67.0908 82.9999ZM86.7879 98.4553V101.56C92.4203 100.417 97.145 96.7743 99.7539 91.8402L97.1504 90.2781C95.0681 94.3183 91.3063 97.3517 86.7879 98.4553Z"
        fill="white"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="61"
        y="59"
        width="44"
        height="48"
      >
        <line
          x1="64.3637"
          y1="71.8751"
          x2="102.797"
          y2="94.6947"
          stroke="white"
          stroke-width="2.27273"
          stroke-linecap="round"
        />
        <line
          x1="83.1897"
          y1="60.6515"
          x2="83.1897"
          y2="105.348"
          stroke="white"
          stroke-width="2.27273"
          stroke-linecap="round"
        />
        <line
          x1="1.13636"
          y1="-1.13636"
          x2="45.8333"
          y2="-1.13636"
          transform="matrix(-0.859855 0.510539 0.510539 0.859855 103.194 72.2721)"
          stroke="white"
          stroke-width="2.27273"
          stroke-linecap="round"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M83 109.504C97.6378 109.504 109.504 97.6378 109.504 83C109.504 68.3622 97.6378 56.496 83 56.496C68.3622 56.496 56.496 68.3622 56.496 83C56.496 97.6378 68.3622 109.504 83 109.504ZM83 89.3105C86.4852 89.3105 89.3105 86.4852 89.3105 83C89.3105 79.5148 86.4852 76.6895 83 76.6895C79.5148 76.6895 76.6895 79.5148 76.6895 83C76.6895 86.4852 79.5148 89.3105 83 89.3105Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iA"
        x="26.1818"
        y="26.1818"
        width="113.636"
        height="113.636"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.51515" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter1_iA"
        x="51.2544"
        y="47.3395"
        width="62.7336"
        height="70.5633"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.378788" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <linearGradient
        id="paint0_linearA"
        x1="82.9999"
        y1="26.1818"
        x2="82.9999"
        y2="139.818"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
    </defs>
  </svg>
)

export default Center
